import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import TextStyle from '../styles/text.style';

interface Props {
  text: string;
  textStyle?: any;
  style?: any
}

export default function SubTitle(props: Props) {
  return (
    <>
      <Stack direction="row" sx={{ mt: 1, mb: 1, ...props.style }}>
        <Typography variant="h5" style={{ ...TextStyle.subTitle, ...props.style }}>
          {props.text}
        </Typography>
      </Stack>
    </>
  );
}

